import { advantageItems } from '@/mocks/homeData';

export default function AdvantageSection() {
  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3">
            为什么选择久久草
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            久久草的品质承诺
          </h2>
          <p className="max-w-xl mx-auto text-sm md:text-base text-foreground-600 leading-relaxed">
            六大核心优势，为您的绿地保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {advantageItems.map((item) => (
            <div
              key={item.id}
              className="group p-6 md:p-7 bg-background-50 rounded-2xl border border-background-200/70 transition-all duration-400 hover:border-accent-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 transition-all duration-400 group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}